import React, { useState, useEffect } from "react";
import CgFormCreator from "../../../common/CgFormCreator";
import PopupModal from "../../../common/PopupModal";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAmenitiesList,
  fetchAmenityCheckList,
  fetchDeleteAmenity,
  fetchUpdateAmenitiesList,
} from "../../../store/PracticeInfo/AmenitiesActions";
import "./amenities.scss";
import { useLocation } from "react-router-dom";

const Amenities = ({
  onlyPopup = false,
  openAminitiesPopup,
  closePopupCallback = () => { },
  // onSaveTotalCallback = () => {},
}) => {
  const [openPopup, setOpenPopup] = useState(false);
  const [confirmDeleteMap, setConfirmDeleteMap] = useState({});
  const [updateAmenities, setUpdateAmenities] = useState();
  const [aminitiesCheckData, setAminitiesCheckData] = useState();
  const [showError, setShowError] = useState(false);

  const location = useLocation();
  const locationHeaderData = location.pathname.split("/");
  const practiceId = locationHeaderData[2];
  const dispatch = useDispatch();
  const { amenityData, isAminityLoading, aminityErrorMsg, amenityFetchError, amenityFetchErrorMsg } = useSelector(
    (state) => state.practiceAminitiesList
  );

  const { amenityCheckData } = useSelector(
    (state) => state.practiceAminitiesCheckList
  );

  useEffect(() => {
    dispatch(fetchAmenitiesList(practiceId));
  }, [practiceId]);

  useEffect(() => {
    setOpenPopup(openAminitiesPopup);
  }, [openAminitiesPopup]);

  useEffect(() => {
    setAminitiesCheckData(amenityCheckData);
  }, [amenityCheckData]);

  useEffect(() => {
    if (openPopup) {
      dispatch(fetchAmenityCheckList());
    }
  }, [openPopup]);

  useEffect(() => {
    setUpdateAmenities(amenityData);
  }, [amenityData]);

  const getCheckBoxDefault = (val) => {
    const defaultVal = [];
    aminitiesCheckData?.length > 0 && aminitiesCheckData?.map((item1) => {
      const item2 = val?.length > 0 && val?.find((item) => item.name === item1.name);
      if (item2) {
        defaultVal.push(item1.code);
      }
    });
    return defaultVal;
  };

  const amenitySchema = [
    {
      component: "checkbox",
      options: amenityCheckData,
      shouldRenderCheckboxWithBackgroundImageStyle: true,
      keyValues: { label: "name", value: "code" },
      onSelect: () => {},
      defaultValues: getCheckBoxDefault(amenityData),
      name: "AmenitiesCheckbox",
      customRenderLabel: () => {
        return (
          <div className="popup-checkbox-subheading">
            <p>Check all that applies</p>
          </div>
        );
      },
    },
  ];

  const toggleConfirmDelete = (displayId, value) => {
    setConfirmDeleteMap((prev) => ({
      ...prev,
      [displayId]: value,
    }));
  };

  const deleteAPiCall = async (displayId) => {
    if (displayId?.length > 0) {
      const getData = await dispatch(fetchDeleteAmenity({ practiceId, displayId }));
      if (getData?.payload?.success === false) {
        setShowError(true);
        setTimeout(() => {
          setShowError(false);
        }, 2000);
      }
      dispatch(fetchAmenitiesList(practiceId));
    }
    setConfirmDeleteMap({});
  };

  const formSelectCheckbox = (val) => {
    let newArray = [];
    aminitiesCheckData.map((item) => {
      const uniqueId = Math.random().toString(36).slice(2, 10);
      const item2 = val?.find((item1) => item1 === item.code);
      if (item2) {
        newArray.push({ displayId: uniqueId, name: item.name });
      }
    });
    return newArray;
  };

  const generateAmenitiesPayload = (selectedAmenityData) => {
    const updatedAmenitiesCodes = selectedAmenityData?.map(item =>
      amenityCheckData.find(amenity => amenity.name === item.name)
    );
    const updatedAmenities = {
      "amenities": updatedAmenitiesCodes?.map((amenities) => amenities?.code)
    }
    return updatedAmenities;
  };

  const handleUpdateAmenitiesListApi = async (payload) => {
    const getUpdateAmenitiesApi = await dispatch(fetchUpdateAmenitiesList({ practiceId, payload }));
    if (getUpdateAmenitiesApi?.payload?.success === false) {
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 2000);
      return;
    }
    dispatch(fetchAmenitiesList(practiceId));
  };

  const RenderFOrmCreatorForAmenity = () => {
    if (isAminityLoading) return null;
    return (
      <div className="amenity-CG-Form">
        <CgFormCreator
          formClassName="amenity-form"
          primaryButton="Save"
          onSubmitCallback={(val) => {
            const convertedData = formSelectCheckbox(val["AmenitiesCheckbox"]);
            setUpdateAmenities(convertedData);
            const amenitiesPayload = generateAmenitiesPayload(convertedData);
            handleUpdateAmenitiesListApi(amenitiesPayload);
            setOpenPopup(!openPopup);
            closePopupCallback("success");
          }}
          schema={amenitySchema}
          onCancel={() => {
            closePopupCallback();
            setOpenPopup(false);
          }}
        />
      </div>
    );
  };

  const RenderAmenityPopupModal = () => {
    return (
      <div>
        <PopupModal
          customRender={RenderFOrmCreatorForAmenity}
          isOpen={openPopup}
          onSave={() => {
            setOpenPopup(!openPopup);
            closePopupCallback("success");
          }}
          onClose={() => {
            setOpenPopup(!openPopup);
            closePopupCallback();
          }}
          popupHeading={"Add Amenities"}
          width="83%"
        />
      </div>
    );
  };

  const RenderAmenitiesError = () => {
    if (!showError) return null;
    return (
      <div className="overlay-alert alert alert-danger" role="alert">
        {aminityErrorMsg}
      </div>
    );
  };

  const RenderAminitySection = () => {
    if (isAminityLoading) return null;
    return (
      <div>
        {amenityData?.length === 0 ?
          <div className="noDataInformationWrapper">
            No Amenities data for this practice
          </div>
          :
          <div>
            {updateAmenities?.length > 0 && updateAmenities?.map((item) => {
              return item.name?.length > 0 ? (
                <div key={item.displayId} className="gencert-list">
                  {item.name}
                  <div className="deleteBtnwithConfirm">
                    {confirmDeleteMap[item.displayId] && (
                      <button
                        type="button"
                        className="btn border-0 canceldelete"
                        onClick={() => toggleConfirmDelete(item.displayId, false)}
                      >
                        CANCEL
                      </button>
                    )}
                    <button
                      type="button"
                      className={`btn ${confirmDeleteMap[item.displayId] ? "deleteConfirmation" : "border-0"
                        }`}
                      onClick={() => {
                        if (confirmDeleteMap[item.displayId]) {
                          deleteAPiCall(item.displayId);
                        } else {
                          toggleConfirmDelete(item.displayId, true);
                        }
                      }}
                    >
                      {confirmDeleteMap[item.displayId] ? "CONFIRM" : "DELETE"}
                    </button>
                  </div>
                </div>
              ) : null;
            })}
          </div>
        }
      </div>
    );
  };

  return (
    <div>
      {!onlyPopup && (
        <h3 className="section-header top-thirty overview">
          Amenities
          <a
            className="btn edit-button"
            onClick={() => {
              setOpenPopup(!openPopup);
            }}
          >
            +Add
          </a>
        </h3>
      )}
      {amenityFetchError ?
        <div className="alert alert-danger" role="alert">
          {amenityFetchErrorMsg}
        </div>
        : null}
      {RenderAmenitiesError()}
      {!onlyPopup && RenderAminitySection()}
      {openPopup && RenderAmenityPopupModal()}
    </div>
  );
};
export default Amenities;
